import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Users, FileText, Inbox, Calculator as CalcIcon, Package, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const Card = ({ icon: Icon, label, primary, sub, to, testid }) => (
  <Link to={to} className="mbw-card p-6 block group" data-testid={testid}>
    <div className="flex items-center justify-between mb-4">
      <div className="w-11 h-11 rounded-lg bg-[#1A2433] flex items-center justify-center">
        <Icon className="w-5 h-5 text-[#DC2626]" />
      </div>
      <ArrowRight className="w-4 h-4 text-slate-400 group-hover:text-[#991B1B] transition-colors" />
    </div>
    <div className="font-heading text-3xl font-bold text-[#1A2433] tabular-nums">{primary}</div>
    <div className="text-sm text-slate-500 mt-1">{label}</div>
    {sub && <div className="text-xs mt-2 text-[#991B1B] font-semibold">{sub}</div>}
  </Link>
);

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then(({ data }) => setStats(data));
  }, []);

  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-8 md:p-10" data-testid="admin-dashboard">
      <h1 className="font-heading text-3xl font-bold text-[#1A2433] mb-2">Übersicht</h1>
      <p className="text-slate-600 mb-8">Schnellzugriff auf alle Bereiche.</p>

      {!stats ? (
        <div className="text-slate-500">Lade Statistiken…</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <Card
            icon={FileText}
            label="Onboarding-Anfragen"
            primary={stats.intakes.total}
            sub={stats.intakes.new ? `${stats.intakes.new} unbearbeitet` : "alle bearbeitet"}
            to="/admin/anfragen"
            testid="stat-intakes"
          />
          <Card
            icon={Inbox}
            label="Kontakt-Nachrichten"
            primary={stats.contacts.total}
            sub={stats.contacts.new ? `${stats.contacts.new} neu` : "keine neuen"}
            to="/admin/kontakt"
            testid="stat-contacts"
          />
          <Card
            icon={Users}
            label="Registrierte Kunden"
            primary={stats.customers}
            to="/admin/kunden"
            testid="stat-customers"
          />
          <Card
            icon={Package}
            label="Vorratsgesellschaften"
            primary={`${stats.vorrats.available}/${stats.vorrats.total}`}
            sub={`${stats.vorrats.sold} verkauft`}
            to="/admin/vorrats"
            testid="stat-vorrats"
          />
          <Card
            icon={CalcIcon}
            label="Gespeicherte Angebote"
            primary={stats.estimates}
            to="/admin/kalkulator"
            testid="stat-estimates"
          />
        </div>
      )}
    </div>
  );
}
